export default {
    maxMobile: 768,
    appURL: "https://edlogix.com/",
    autoUpdate: 3600000,
    favIcon: "images/EdLogixIcon.png",
    routerEndPoint: "edl/url",
    reqAuth: false,
    authURL: "/login",
    unauthURL: "/unathorized",
    origins: {
        "https://wp.edlogix.com:1234": {
            analytics: {
                isActive: true,
                debug: true,
                tag: "G-N5XY11DNHX",
                config: {
                    "send_page_view": false
                }
            },
            apiClient: {
                server: "https://api.birdhouse-demos.com",
                auth: {
                    jwtKey: "jwt",
                    endPoint: "edl/auth"
                },
                headers: {
                    "x-siteid": 9010
                },
                options: {
                    croddDomain: true,
                    xhrFields: { withCredentials: true },
                    credentials: "include",
                    cache: "no-store"
                }
            },
            static: "https://staticlocal.edlogix.com/edl/",
            isDevEnv: true
        },
        default: {
            analytics: {
                isActive: true,
                debug: false,
                tag: "G-9P34VCTTX5",
                config: {
                    "send_page_view": false
                }
            },
            apiClient: {
                server: "https://api.birdhouse-demos.com",
                auth: {
                    jwtKey: "jwt",
                    endPoint: "edl/auth"
                },
                options: {
                    croddDomain: true,
                    xhrFields: { withCredentials: true },
                    credentials: "include",
                    cache: "no-store"
                }
            },
            static: "https://static.edlogix.com/",
            isDevEnv: false
        }
    },
    routes: {
        form: {
            endPoint: "edl/form",
            resultId: "SiteForm"
        }
    },
    menus: {
        header: {
            name: "Main Menu",
            class2: [
                "ed-main-menu"
            ],
            options: [
                {
                    name: "Navigation Menu",
                    options: [
                        {
                            title: "Web Development",
                            href: "/web-development/"
                        },
                        {
                            title: "Digital Marketing",
                            href: "/digital-marketing/"
                        },
                        {
                            title: "Cyber Security",
                            href: "/cybersecurity/"
                        },
                        {
                            title: "About Us",
                            href: "/about/"
                        }
                    ]
                }
            ]
        },
        footer: {
            name: "Menu",
            options: [
                {
                    title: "Web Development",
                    href: "/web-development/"
                },
                {
                    title: "Digital Marketing",
                    href: "/digital-marketing/"
                },
                {
                    title: "Cyber Security",
                    href: "/cybersecurity/"
                },
                {
                    title: "About Us",
                    href: "/about/"
                }
            ]
        },
        locations: {
            name: "Locations",
            options: [
                {
                    title: "Houston, TX - USA",
                    email: "us@edlogix.com"
                },
                {
                    title: "Mexico City - MX",
                    email: "mx@edlogix.com"
                }
            ]
        }
    }
}